module.exports = __webpack_public_path__ + "img/tick.da188ccb.png";